<div class="health-records">
  <span class="header">Health Records</span>

  <div class="health-record">
    <img src="assets/health-records/folders-solid.png" />
    <span class="label">All Records</span>
    <span class="badge">914</span>
  </div>

  <div class="health-record">
    <img src="assets/health-records/virus-solid.png" />
    <span class="label">Allergies</span>
    <span class="badge">5</span>
  </div>

  <div class="health-record">
    <img src="assets/health-records/list-ul-solid.png" />
    <span class="label">Conditions</span>
    <span class="badge">34</span>
  </div>

  <div class="health-record">
    <img src="assets/health-records/syringe-solid.png" />
    <span class="label">Immunizations</span>
    <span class="badge">3</span>
  </div>

  <div class="health-record">
    <img src="assets/health-records/flask-solid.png" />
    <span class="label">Lab Results</span>
    <span class="badge">423</span>
  </div>

  <div class="health-record">
    <img src="assets/health-records/prescription-bottle-solid.png" />
    <span class="label">Medications</span>
    <span class="badge">38</span>
  </div>

  <div class="health-record">
    <img src="assets/health-records/file-lines-solid.png" />
    <span class="label">Procedures</span>
    <span class="badge">8</span>
  </div>

  <div class="health-record">
    <img src="assets/health-records/file-waveform-solid.png" />
    <span class="label">Vitals</span>
    <span class="badge">322</span>
  </div>
</div>
